/**
 * AddContractorWrapper
 *
 * Purpose:
 * - Wraps the contractor add/edit screen to keep vendor context.
 * - Reads returnTab/returnSubTab from URL and redirects back to vendor pages.
 * - If invoked from vendor orders create WO flow (returnTo=create-wo), returns to create WO with preserved tab.
 */
import React from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import AddSubContractor from '../contractors/add-sub-contractor';
import { VENDOR, VENDOR_LIST, VENDOR_ORDERS, CREATE_WORK_ORDER } from '../../constants/route-paths';
import { VENDOR_STATUS, VENDOR_TAB, VENDOR_URL_PARAM } from '../../constants/vendor.contant';

function AddContractorWrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    // Get return tab parameters from URL using hook
    const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB) || VENDOR_TAB.CONTRACTORS;
    const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB) || VENDOR_STATUS.ACTIVE;
    const returnTo = searchParams.get('returnTo');

    // Override the history prop to redirect to vendor list
    const customHistory = (dest, options) => {
        if (location.state?.returnTo) {
            navigate(location.state.returnTo, options || {
                state: {
                    ...location.state,
                    openUploadCostModal: true
                }
            });
        } else if (returnTo === 'create-wo') {
            navigate(`/${VENDOR}/${VENDOR_ORDERS}/${CREATE_WORK_ORDER}?${VENDOR_URL_PARAM.TAB}=${returnTab}`);
        } else {
            navigate(`/${VENDOR}/${VENDOR_LIST}?${VENDOR_URL_PARAM.TAB}=${returnTab}&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`);
        }
    };

    const handleClose = () => {
        if (location.state?.returnTo) {
            navigate(location.state.returnTo, {
                state: {
                    ...location.state,
                    openUploadCostModal: true
                }
            });
        } else if (returnTo === 'create-wo') {
            navigate(`/${VENDOR}/${VENDOR_ORDERS}/${CREATE_WORK_ORDER}?${VENDOR_URL_PARAM.TAB}=${returnTab}`);
        } else {
            navigate(`/${VENDOR}/${VENDOR_LIST}?${VENDOR_URL_PARAM.TAB}=${returnTab}&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`);
        }
    };

    // Pass through all props from RBAC (including writePermission)
    return <AddSubContractor
        {...props}
        history={customHistory}
        handleClose={handleClose}
    />;
}

export default AddContractorWrapper;
